module.exports = __webpack_public_path__ + "static/media/workshop.e1a46deb.jpg";